import styled from 'styled-components';

const Label = styled.span`
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI17R};
  color: ${({ theme, color }) => (!!color ? color : theme.DF_COLOR.GRAY900)};
  margin-right: 8px;
`;

export default Label;
